import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { UilabMatTabsModule } from '@uilab/ng-mat-components';
import { Highlight } from 'ngx-highlightjs';
import { UILAB_NG_MAT_COMPONENTS_PACKAGE } from '../../shared/constants/dependencies.constants';
import { HeaderComponent } from '../../shared/components/header/header.component';

interface GetStartedExampleTab {
    readonly id: 'standalone' | 'ngmodule';
    readonly label: string;
    readonly code: string;
    readonly language: 'typescript';
}

@Component({
    selector: 'avd-get-started-page',
    templateUrl: './get-started-page.component.html',
    styleUrls: ['./get-started-page.component.scss'],
    standalone: true,
    imports: [HeaderComponent, Highlight, RouterLink, UilabMatTabsModule],
})
export class GetStartedPageComponent {
    readonly packageName = UILAB_NG_MAT_COMPONENTS_PACKAGE;

    readonly installCommand = `npm install ${this.packageName}`;

    readonly stylesSnippet = `"styles": [
  "node_modules/${this.packageName}/assets/scss/core/aveva.scss",
];`;

    readonly importTabs: readonly GetStartedExampleTab[] = [
        {
            id: 'standalone',
            label: 'Standalone',
            language: 'typescript',
            code: `import { UilabMatButton } from '${this.packageName}';

@Component({
  standalone: true,
  imports: [
    UilabMatButton,
  ],
})`,
        },
        {
            id: 'ngmodule',
            label: 'NgModule',
            language: 'typescript',
            code: `import { UilabMatButton } from '${this.packageName}';

@NgModule({
  imports: [
    ...
    UilabMatButton,
    ...
  ],
})`,
        },
    ];

    activeImportTab: GetStartedExampleTab['id'] = 'standalone';

    setImportTab(tabId: GetStartedExampleTab['id']): void {
        this.activeImportTab = tabId;
    }

    selectedImportTab(): GetStartedExampleTab {
        const tab = this.importTabs.find(
            (item) => item.id === this.activeImportTab,
        );

        if (!tab) {
            return this.importTabs[0];
        }

        return tab;
    }
}
